// extracted by mini-css-extract-plugin
export default {"ace-c-admin-logo":"ace-admin-logo---0ac96e91"};